import { apiStudent } from '@/lib/api-manager'
import type { Request } from '@/types/requests/request'

export async function getStudentRequestById(id: string) {
  const response = await apiStudent.get(`v1/requests/request/${id}`)
  const data: Request = response.data.data
  return data
}
